import { render, staticRenderFns } from "./PackingContentsV2.vue?vue&type=template&id=4e989e4f&scoped=true&"
import script from "./PackingContentsV2.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PackingContentsV2.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PackingContentsV2.vue?vue&type=style&index=0&id=4e989e4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e989e4f",
  null
  
)

export default component.exports